import React, { useState, useEffect } from "react";
import { SnackbarProvider } from "../components/SnackbarProvider";
import { ProductListPage } from "./products/ProductListPage";
import { DemoShipmentFeedPage } from "./products/demoShipmentFeed/DemoShipmentFeedPage";
import { EmailAutomationPage } from "./products/emailAutomation/EmailAutomationPage";
import { ShipmentTimelineAndAutomationPage } from "./products/shipmentTimelineAndAutomation/ShipmentTimelineAndAutomationPage";

type ProductRoute = "products" | "demoShipmentFeed" | "emailAutomation" | "shipmentTimelineAndAutomation";

function getProductFromHash(): ProductRoute {
  const hash = window.location.hash.slice(1); // Remove #

  // Parse /products/<productName> format
  if (hash.startsWith("/products/")) {
    const productName = hash.replace("/products/", "");
    if (productName === "demoShipmentFeed") {
      return "demoShipmentFeed";
    }
    if (productName === "emailAutomation") {
      return "emailAutomation";
    }
    if (productName === "shipmentTimelineAndAutomation") {
      return "shipmentTimelineAndAutomation";
    }
  }

  // Default to products list
  return "products";
}

export interface OutlookLoggedInContentProps {
  DebugMenu?: React.ComponentType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ChatComponent?: React.ComponentType<any>;
}

export const OutlookLoggedInContent: React.FC<OutlookLoggedInContentProps> = ({
  DebugMenu,
  ChatComponent,
}) => {
  const [currentProduct, setCurrentProduct] =
    useState<ProductRoute>(getProductFromHash);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentProduct(getProductFromHash());
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const navigateToProduct = (productName: string) => {
    window.location.hash = `/products/${productName}`;
  };

  const navigateToProductList = () => {
    window.location.hash = "";
  };

  let content: React.ReactNode;
  switch (currentProduct) {
    case "demoShipmentFeed":
      content = (
        <DemoShipmentFeedPage
          onBack={navigateToProductList}
          ChatComponent={ChatComponent}
        />
      );
      break;
    case "emailAutomation":
      content = (
        <EmailAutomationPage
          onBack={navigateToProductList}
        />
      );
      break;
    case "shipmentTimelineAndAutomation":
      content = (
        <ShipmentTimelineAndAutomationPage
          onBack={navigateToProductList}
        />
      );
      break;
    case "products":
    default:
      content = (
        <ProductListPage
          onProductSelect={navigateToProduct}
        />
      );
  }

  return (
    <SnackbarProvider>
      {content}
      {DebugMenu && <DebugMenu />}
    </SnackbarProvider>
  );
};
